
export default defineNuxtRouteMiddleware((to, from) => {
  // Remove trailing slash
  if (to.path.endsWith('/') && to.path !== '/') {
    return navigateTo(to.path.slice(0, -1), { redirectCode: 301 })
  }
})